import { DividerComponent } from "@/components";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, ButtonBase, Menu, Radio, Stack, Typography } from "@mui/material";
import { useState } from "react";
import EmiOption from "./emi-options";

const DIVIDER_COLOR = "#DDEFE2";

export default function TenureSelect({
  label,
  value,
  menuItems = [],
  onChange,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <Box>
      <Typography
        fontSize={{ md: "20px", xs: "16px" }}
        fontWeight={500}
        mb={1}
        color={"#1F1F1FCC"}
      >
        {label}
      </Typography>
      <ButtonBase
        onClick={handleClick}
        sx={{
          width: "100%",
          borderRadius: "12px",
          padding: "12px",
          border: "1px solid #004135",
          justifyContent: "space-between",
          bgcolor: "#E4F9E4",
        }}
      >
        <Stack direction="row" alignItems="center" gap={1}>
          <Radio
            checked={true}
            color="success"
            disableRipple
            sx={{
              p: 0.25,
              "& .MuiSvgIcon-root": { fontSize: 18 },
            }}
            inputProps={{ "aria-label": label }}
          />
          <Typography fontWeight={500}>{value?.value} months</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography fontWeight={600}>{value?.name}</Typography>
          <ExpandMoreIcon
            sx={{
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.2s",
            }}
          />
        </Stack>
      </ButtonBase>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: "12px",
            mt: 1,
            width: anchorEl ? anchorEl.offsetWidth : undefined,
          },
        }}
      >
        {menuItems?.map((opt, idx) => (
          <>
            <EmiOption
              key={opt.value}
              label={`${opt.value} months`}
              amount={parseInt(opt.name.replace(/[^0-9]/g, ""))}
              selected={opt.value === value?.value}
              onClick={() => {
                onChange(opt);
                handleClose();
              }}
            />
            {idx < menuItems.length - 1 && (
              <DividerComponent
                sx={{
                  ml: 2,
                  mr: 2,
                  opacity: 1,
                  display: { xs: "none", sm: "block" },
                }}
              />
            )}
          </>
        ))}
      </Menu>
    </Box>
  );
}
